import { createSlice } from '@reduxjs/toolkit';
import { defaultGenericPagableState, GenericPageableState } from '../model';
import { addGenericPageableStateListBuilders } from '../slice';
import { DemoCredentialListItem, getDemoCredentials } from './DemoCredentialListApi';
import { RootState } from '../../store';

export interface DemoCredentialListState extends GenericPageableState<DemoCredentialListItem> {
}

export const demoCredentialListSlice = createSlice({
    name: 'DemoCredentialList',
    initialState: defaultGenericPagableState,
    reducers: {},
    extraReducers: builder => {
        addGenericPageableStateListBuilders(builder, getDemoCredentials);
    },
});

export const demoCredentialListSelector = (state: RootState) => state.demoCredentialListState;
